/* ==================== OPTIMIZED CLS-FRIENDLY JAVASCRIPT ==================== */

// 1. PERFORMANCE UTILITIES
function defineNewReady() {
    const listeners = [];
    const doc = window.document;
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    let observer;

    function ready(selector, fn) {
        listeners.push({ selector, fn });
        if (!observer) {
            observer = new MutationObserver(() => {
                requestAnimationFrame(check);
            });
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: false,
                attributes: false,
                characterData: false
            });
        }
        setTimeout(check, 100);
    }

    function check() {
        for (let i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            elements = doc.querySelectorAll(listener.selector);
            for (let j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                if (!element.ready) element.ready = [];
                if (!element.ready[i]) {
                    element.ready[i] = true;
                    Promise.resolve().then(() => {
                        listener.fn.call(element, element);
                    });
                }
            }
        }
    }
    
    window.NewReady = ready;
}

defineNewReady();
// 2. OFFER PRICE CALCULATOR
function initOfferCalculator() {
    function parseDisplayPrice(priceText) {
        if (!priceText) return NaN;

        let text = String(priceText)
            .replace(/\u00A0/g, " ")
            .replace(/Rs\.?|₹|INR|USD|\$|€|£/gi, "")
            .trim();

        // Keep only digits and separators
        text = text.match(/[\d.,]+/g)?.join("") || "";
        if (!text) return NaN;

        const lastDot = text.lastIndexOf(".");
        const lastComma = text.lastIndexOf(",");

        let decimalSep = null;

        // If both exist, whichever appears last is treated as decimal separator
        if (lastDot !== -1 && lastComma !== -1) {
            decimalSep = lastDot > lastComma ? "." : ",";
        } else if (lastDot !== -1) {
            const digitsAfter = text.length - lastDot - 1;
            // Treat as decimal only when it looks like .00 / .50 etc.
            if (digitsAfter >= 1 && digitsAfter <= 2) decimalSep = ".";
        } else if (lastComma !== -1) {
            const digitsAfter = text.length - lastComma - 1;
            if (digitsAfter >= 1 && digitsAfter <= 2) decimalSep = ",";
        }

        let normalized = text;

        if (decimalSep) {
            const parts = text.split(decimalSep);
            const intPart = parts[0].replace(/[.,]/g, "");
            const decPart = parts.slice(1).join("").replace(/[.,]/g, "").slice(0, 2);
            normalized = intPart + "." + decPart;
        } else {
            normalized = text.replace(/[.,]/g, "");
        }

        const value = Number(normalized);
        if (!Number.isFinite(value)) return NaN;

        return Math.round(value);
    }

    NewReady("div#offerAmountInput input#OfferInput", function(ele) {
        const parentContainer = ele.closest('div#offerAmountInput');
        if (parentContainer) {
            parentContainer.style.minHeight = '120px';
        }

        let priceText = jQuery(".single-product .paira-product span.paira-default-price span.money")
            .first()
            .text()
            .trim();

        if (!priceText) return;

        let proPrice = parseDisplayPrice(priceText);
        if (isNaN(proPrice) || proPrice <= 0) return;

        let minPercent;
        if (proPrice <= 10000) {
            minPercent = (proPrice - 500) / proPrice;
        } else if (proPrice < 15000) {
            minPercent = 0.80;
        } else if (proPrice < 50000) {
            minPercent = 0.80;
        } else if (proPrice < 100000) {
            minPercent = 0.85;
        } else if (proPrice < 200000) {
            minPercent = 0.90;
        } else {
            minPercent = 0.95;
        }

        // Add ₹5000 to minimum offer for non-India customers
        const customerCountry = String(window.CUSTOMER_COUNTRY || "IN").toUpperCase();
        const extraMin = customerCountry === "IN" ? 0 : 5000;

        const baseMinRange = Math.floor(proPrice * minPercent);
        let finalMinRange = baseMinRange + extraMin;
        let maxRange = proPrice;

        if (finalMinRange > maxRange) {
            finalMinRange = maxRange;
        }

        const existingRange = jQuery(ele).siblings(".offerRange")[0];
        if (existingRange) {
            existingRange.style.display = 'none';
            setTimeout(() => existingRange.remove(), 50);
        }

        const offerRangeEl = document.createElement('p');
        offerRangeEl.className = 'offerRange';
        offerRangeEl.style.cssText = 'opacity: 0; transition: opacity 0.3s ease; margin-top: 10px;';
        offerRangeEl.innerHTML = `
            You can offer between 
            <strong>₹${finalMinRange.toLocaleString("en-IN")}</strong> 
            and 
            <strong>₹${maxRange.toLocaleString("en-IN")}</strong>.
            <br>
            <small>Final acceptance remains at our discretion.</small>
        `;

        ele.parentNode.insertBefore(offerRangeEl, ele.nextSibling);

        requestAnimationFrame(() => {
            offerRangeEl.style.opacity = '1';
        });

        jQuery(ele)
            .off("keyup.offerValidation change.offerValidation")
            .on("keyup.offerValidation change.offerValidation", (event) => {
                clearTimeout(ele.validationTimeout);
                ele.validationTimeout = setTimeout(() => {
                    // --- FIX START: proper parsing of decimal input ---
                    let rawVal = jQuery(event.currentTarget).val().trim();
                    // Remove commas used as thousand separators
                    let cleaned = rawVal.replace(/,/g, '');
                    // Parse as float (respects decimal point) and round to whole number
                    let inputValue = Math.round(parseFloat(cleaned) || 0);
                    // --- FIX END ---

                    let $cta = jQuery(
                        ".offerly-modal-content-group div#leftSide > div:not(#leftContent) button"
                    );

                    if (inputValue >= finalMinRange && inputValue <= maxRange) {
                        $cta.addClass("activeOfferCTA");
                    } else {
                        $cta.removeClass("activeOfferCTA");
                    }
                }, 100);
            });

        setTimeout(() => {
            jQuery(ele).trigger("change.offerValidation");
        }, 50);
    });
}
// 3. RESERVE BUTTON FUNCTIONALITY
function initReserveButton() {

    const $popup = jQuery('.cu-reserve-pop-container');

    if (!$popup.length) return;

    // Move popup directly under body
    if (!$popup.parent().is('body')) {
        $popup.appendTo('body');
    }

    const popupEl = $popup.get(0);
    const $modal = $popup.find('.cu-reserve-pop');
    const modalEl = $modal.get(0);

    if (!popupEl || !modalEl) return;

    function setImportant(element, property, value) {
        element.style.setProperty(property, value, 'important');
    }

    /*
     * ---------------------------------------------------------
     * FORCE POPUP CLOSED ON PAGE LOAD
     * ---------------------------------------------------------
     */
    setImportant(popupEl, 'visibility', 'hidden');
    setImportant(popupEl, 'opacity', '0');
    setImportant(popupEl, 'pointer-events', 'none');

    $popup.removeClass('active');
    jQuery('body').removeClass('reserve-pop-active');
    jQuery('html, body').css('overflow', '');

    /*
     * ---------------------------------------------------------
     * POPUP CONTAINER
     * ---------------------------------------------------------
     */
    setImportant(popupEl, 'position', 'fixed');
    setImportant(popupEl, 'top', '0');
    setImportant(popupEl, 'left', '0');
    setImportant(popupEl, 'right', '0');
    setImportant(popupEl, 'bottom', '0');
    setImportant(popupEl, 'width', '100vw');
    setImportant(popupEl, 'height', '100vh');
    setImportant(popupEl, 'display', 'flex');
    setImportant(popupEl, 'align-items', 'center');
    setImportant(popupEl, 'justify-content', 'center');
    setImportant(popupEl, 'padding', '20px');
    setImportant(popupEl, 'box-sizing', 'border-box');
    setImportant(popupEl, 'background', 'rgba(0, 0, 0, 0.50)');
    setImportant(popupEl, 'z-index', '2147483647');
    setImportant(popupEl, 'overflow-y', 'auto');

    /*
     * ---------------------------------------------------------
     * POPUP MODAL
     * ---------------------------------------------------------
     */
    setImportant(modalEl, 'position', 'relative');
    setImportant(modalEl, 'top', 'auto');
    setImportant(modalEl, 'left', 'auto');
    setImportant(modalEl, 'right', 'auto');
    setImportant(modalEl, 'bottom', 'auto');
    setImportant(modalEl, 'width', '100%');
    setImportant(modalEl, 'max-width', '460px');
    setImportant(modalEl, 'max-height', '90vh');
    setImportant(modalEl, 'margin', 'auto');
    setImportant(modalEl, 'background', '#fff');
    setImportant(modalEl, 'transform', 'none');
    setImportant(modalEl, 'overflow-y', 'auto');
    setImportant(modalEl, 'box-sizing', 'border-box');
    setImportant(modalEl, 'z-index', '2147483647');

    /*
     * ---------------------------------------------------------
     * OPEN RESERVE POPUP
     * ---------------------------------------------------------
     */
    jQuery(document)
        .off('click.reserve', 'a#reserve-btn')
        .on('click.reserve', 'a#reserve-btn', function(event) {

            const href = jQuery(this).attr('href');

            if (!href || href === '#') {

                event.preventDefault();

                setImportant(popupEl, 'visibility', 'visible');
                setImportant(popupEl, 'opacity', '1');
                setImportant(popupEl, 'pointer-events', 'auto');

                $popup.addClass('active');
                jQuery('body').addClass('reserve-pop-active');
                jQuery('html, body').css('overflow', 'hidden');
            }
        });

    /*
     * ---------------------------------------------------------
     * CLOSE BUTTON
     * ---------------------------------------------------------
     */
    jQuery(document)
        .off('click.reserveClose', '.cu-reserve-pop-header button')
        .on('click.reserveClose', '.cu-reserve-pop-header button', function(event) {

            event.preventDefault();

            setImportant(popupEl, 'opacity', '0');
            setImportant(popupEl, 'pointer-events', 'none');

            setTimeout(function() {

                $popup.removeClass('active');

                setImportant(popupEl, 'visibility', 'hidden');
                setImportant(popupEl, 'opacity', '0');
                setImportant(popupEl, 'pointer-events', 'none');

                jQuery('body').removeClass('reserve-pop-active');
                jQuery('html, body').css('overflow', '');

            }, 300);
        });

    /*
     * ---------------------------------------------------------
     * CLOSE WHEN CLICKING OUTSIDE MODAL
     * ---------------------------------------------------------
     */
    jQuery(document)
        .off('click.reserveOutside', '.cu-reserve-pop-container')
        .on('click.reserveOutside', '.cu-reserve-pop-container', function(event) {

            if (event.target === popupEl) {

                setImportant(popupEl, 'opacity', '0');
                setImportant(popupEl, 'pointer-events', 'none');

                setTimeout(function() {

                    $popup.removeClass('active');

                    setImportant(popupEl, 'visibility', 'hidden');
                    setImportant(popupEl, 'opacity', '0');
                    setImportant(popupEl, 'pointer-events', 'none');

                    jQuery('body').removeClass('reserve-pop-active');
                    jQuery('html, body').css('overflow', '');

                }, 300);
            }
        });

    /*
     * ---------------------------------------------------------
     * CLOSE WITH ESCAPE KEY
     * ---------------------------------------------------------
     */
    jQuery(document)
        .off('keydown.reserveEsc')
        .on('keydown.reserveEsc', function(event) {

            if (event.key === 'Escape' && $popup.hasClass('active')) {

                setImportant(popupEl, 'opacity', '0');
                setImportant(popupEl, 'pointer-events', 'none');

                setTimeout(function() {

                    $popup.removeClass('active');

                    setImportant(popupEl, 'visibility', 'hidden');
                    setImportant(popupEl, 'opacity', '0');
                    setImportant(popupEl, 'pointer-events', 'none');

                    jQuery('body').removeClass('reserve-pop-active');
                    jQuery('html, body').css('overflow', '');

                }, 300);
            }
        });
}

// 4. MOBILE IMAGE SLIDER
function initMobileSlider() {
    if (window.innerWidth >= 768) return;
    
    const checkForSlider = () => {
        const hasProducts = document.querySelectorAll(".single-product.paira-gap-3").length > 0;
        const hasImages = document.querySelectorAll(".product-page-template-4 .single-product-image-list a").length > 0;
        
        if (!hasProducts || !hasImages) {
            setTimeout(checkForSlider, 100);
            return;
        }
        
        const sliderContainer = document.createElement('div');
        sliderContainer.className = 'cu-product-cat-wrapper';
        sliderContainer.style.cssText = `
            min-height: 300px;
            opacity: 0;
            transition: opacity 0.3s ease;
            contain: layout;
        `;
        
        jQuery(".single-product.paira-gap-3").before(sliderContainer);
        
        document.querySelectorAll(".product-page-template-4 .single-product-image-list a")
            .forEach((ele, i) => {
                let imgSrc = jQuery(ele).attr("data-zoom-image");
                const imgContainer = document.createElement('div');
                imgContainer.className = 'u-product-cat-item';
                imgContainer.style.cssText = 'aspect-ratio: 1/1; width: 100%;';
                
                const img = document.createElement('img');
                img.src = imgSrc;
                img.loading = 'lazy';
                img.decoding = 'async';
                img.width = 400;
                img.height = 400;
                img.alt = 'Product image ' + (i + 1);
                img.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
                
                imgContainer.appendChild(img);
                sliderContainer.appendChild(imgContainer);
            });
        
        if (document.querySelectorAll('.u-product-cat-item').length <= 1) {
            sliderContainer.style.opacity = '1';
            return;
        }
        
        loadSlickSlider(sliderContainer);
    };
    
    function loadSlickSlider(container) {
        if (typeof jQuery.fn.slick !== 'undefined') {
            initSlick(container);
            return;
        }
        
        if (!document.querySelector('link[href*="slick-carousel"]')) {
            ['https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.css',
             'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.min.css']
            .forEach(href => {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                document.head.appendChild(link);
            });
        }
        
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
        script.onload = () => initSlick(container);
        document.head.appendChild(script);
    }
    
    function initSlick(container) {
        jQuery(container).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            lazyLoad: 'ondemand',
            autoplay: false,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            speed: 300
        });
        
        container.style.opacity = '1';
    }
    
    setTimeout(checkForSlider, 500);
}

// 5. OFFER BUTTON CLICK HANDLER
function initOfferButton() {
    jQuery(document).on('click', 'a#make_offer_btn', (event) => {
        event.preventDefault();
        const offerButton = jQuery('.button_flex_col button#offerButton')[0];
        if (offerButton) {
            requestAnimationFrame(() => {
                offerButton.click();
            });
        }
    });
}

// 6. SMART PAGINATION FIX
function initSmartPagination() {
    const isSearchPage = window.location.pathname.includes('/search');
    const isCollectionPage = window.location.pathname.includes('/collections/');
    
    if (!isSearchPage && !isCollectionPage) return;
    
    console.log('Initializing smart pagination...');
    
    setTimeout(() => {
        fixPaginationLogic();
    }, 1500);
}

function fixPaginationLogic() {
    const pagination = document.querySelector('.pagination, .paginate, .pager, .paging, .paginates, .collection-pagination');
    
    if (!pagination) {
        console.log('No pagination found on this page');
        return;
    }
    
    console.log('Found pagination:', pagination.className);
    
    const productSelectors = [
        '.product-con',
        '.product-item',
        '.product-grid-item', 
        '.collection-grid-item',
        '.grid-item',
        '.product-block',
        '.product-card'
    ];
    
    let products = [];
    productSelectors.forEach(selector => {
        const found = document.querySelectorAll(selector);
        if (found.length > 0) {
            products = Array.from(found);
        }
    });
    
    console.log(`Found ${products.length} products on current page`);
    
    if (products.length === 0) {
        console.log('No products found, skipping pagination fix');
        return;
    }
    
    const isSearchPage = window.location.pathname.includes('/search');
    
    if (isSearchPage) {
        fixSearchPagination(pagination, products.length);
    } else {
        fixCollectionPagination(pagination, products.length);
    }
}

function fixSearchPagination(pagination, productsCount) {
    console.log('Fixing search result pagination...');
    
    const productsPerPage = 50;
    const totalPages = Math.ceil(productsCount / productsPerPage);
    
    console.log(`Estimated: ${productsCount} products = ${totalPages} pages`);
    
    const pageLinks = pagination.querySelectorAll('a, span, li');
    
    const currentPage = getCurrentPageNumber();
    console.log(`Current page: ${currentPage}`);
    
    pageLinks.forEach(link => {
        const pageText = link.textContent.trim();
        const pageNum = parseInt(pageText);
        
        if (!isNaN(pageNum) && pageNum > totalPages) {
            console.log(`Hiding empty search page ${pageNum}`);
            link.style.display = 'none';
            link.style.visibility = 'hidden';
            link.style.opacity = '0';
            link.style.pointerEvents = 'none';
        }
    });
    
    const nextButtons = pagination.querySelectorAll('a[rel="next"], .next, .pagination-next');
    nextButtons.forEach(btn => {
        const href = btn.getAttribute('href');
        if (href && href.includes('page=')) {
            const pageMatch = href.match(/page=(\d+)/);
            if (pageMatch) {
                const nextPage = parseInt(pageMatch[1]);
                if (nextPage > totalPages) {
                    console.log(`Disabling next button to empty page ${nextPage}`);
                    btn.style.opacity = '0.5';
                    btn.style.pointerEvents = 'none';
                    btn.setAttribute('disabled', 'disabled');
                }
            }
        }
    });
    
    console.log('Search pagination fixed');
}

function fixCollectionPagination(pagination, productsCount) {
    console.log('Fixing collection pagination...');
    
    const pageLinks = pagination.querySelectorAll('a, span, li');
    const visiblePages = [];
    
    pageLinks.forEach(link => {
        const pageText = link.textContent.trim();
        const pageNum = parseInt(pageText);
        
        if (!isNaN(pageNum)) {
            visiblePages.push(pageNum);
            link.style.display = '';
            link.style.visibility = '';
            link.style.opacity = '';
            link.style.pointerEvents = '';
        }
    });
    
    if (visiblePages.length > 0) {
        const maxPage = Math.max(...visiblePages);
        console.log(`Collection shows up to page ${maxPage}`);
    }
    
    console.log('Collection pagination checked');
}

function getCurrentPageNumber() {
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get('page');
    return pageParam ? parseInt(pageParam) : 1;
}

// 7. AD INJECTION FUNCTION (NEW - Called after sorting)
function injectAdCards(parentContainer) {
    if (!parentContainer) return;
    
    console.log('📢 Injecting ad cards...');
    
    // Remove any previously injected ads
    document.querySelectorAll('.ad-grid-item').forEach(ad => ad.remove());
    
    function createAdHTML(imageUrl, linkUrl) {
        return `
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 margin-top-30 product-con ad-grid-item">
          <a href="${linkUrl}">
            <div class="product-image-container">
              <img src="${imageUrl}" class="img-responsive" alt="Collection Ad">
            </div>
          </a>
        </div>`;
    }
    
    const adCards = [
        {
            pos: 52,
            image: 'https://cdn.shopify.com/s/files/1/0643/7958/4700/files/3_jpg.jpg?v=1775803324',
            link: 'https://confidentialcouture.com/collections/watches-for-men-women'
        },
        {
            pos: 30,
            image: 'https://cdn.shopify.com/s/files/1/0643/7958/4700/files/2_jpg.jpg?v=1775803324',
            link: 'https://confidentialcouture.com/collections/jewellery'
        },
        {
            pos: 9,
            image: 'https://cdn.shopify.com/s/files/1/0643/7958/4700/files/1_jpg_85d6a5be-7fdd-4d55-af5c-017cff3bca32.jpg?v=1775803324',
            link: 'https://confidentialcouture.com/collections/bags-for-women'
        }
    ];
    
    const currentGridItems = Array.from(parentContainer.children).filter(el => !el.classList.contains('ad-grid-item'));
    
    // Sort positions descending to avoid index shifting
    const sortedCards = [...adCards].sort((a, b) => b.pos - a.pos);
    
    sortedCards.forEach(ad => {
        if (currentGridItems.length >= ad.pos) {
            const targetItem = currentGridItems[ad.pos - 1];
            if (targetItem) {
                targetItem.insertAdjacentHTML('beforebegin', createAdHTML(ad.image, ad.link));
                console.log(`✅ Ad inserted at position ${ad.pos}`);
            }
        } else {
            console.warn(`⚠️ Not enough products to insert ad at position ${ad.pos}`);
        }
    });
}
// 8. PRODUCT SORTING BY AVAILABILITY + AD INJECTION
function sortProductsAndInjectAds() {

    const isSearchPage =
        window.location.pathname.includes('/search');

    const isCollectionPage =
        window.location.pathname.includes('/collections/');

    // Do nothing on unrelated pages
    if (!isSearchPage && !isCollectionPage) return;

    setTimeout(() => {

        const productSelectors = [
            '.product-con',
            '.product-item',
            '.product-grid-item',
            '.collection-grid-item',
            '.grid-item',
            '.product-block',
            '.product-card'
        ];

        let productContainers = [];
        let parentContainer = null;

        // Find the actual product container
        for (let selector of productSelectors) {

            const elements = document.querySelectorAll(selector);

            if (elements.length > 0) {
                productContainers = Array.from(elements);
                parentContainer = elements[0].parentNode;
                break;
            }
        }

        if (productContainers.length === 0 || !parentContainer) {
            return;
        }


        // =========================================================
        // COLLECTION PAGE
        // =========================================================
        // IMPORTANT:
        // Do NOT reorder/remove collection products.
        // Shopify/Liquid keeps the original product order.
        // This prevents Reserved / On Hold products from
        // disappearing after the 1-second delay.
        //
        // But still inject the promotional/ad cards.
        // =========================================================

        if (isCollectionPage) {

            console.log(
                'Collection page detected — keeping product order unchanged.'
            );

            if (typeof injectAdCards === 'function') {
                injectAdCards(parentContainer);
            }

            return;
        }


        // =========================================================
        // SEARCH PAGE
        // =========================================================
        // Search pages can still use your availability sorting.
        // =========================================================

        if (isSearchPage) {

            console.log(
                'Search page detected — sorting products by availability.'
            );

            const availableProducts = [];
            const onHoldProducts = [];
            const outOfStockProducts = [];

            productContainers.forEach(product => {

                const productText =
                    product.textContent.toLowerCase();

                const productHtml =
                    product.innerHTML.toLowerCase();

                const outOfStockSelectors =
                    product.querySelectorAll(
                        '.out-of-stock, .sold-out, .unavailable, .oos'
                    );

                const onHoldSelectors =
                    product.querySelectorAll(
                        '.on-hold, .reserved, .pre-order'
                    );


                // OUT OF STOCK
                if (
                    productText.includes('out of stock') ||
                    productText.includes('sold out') ||
                    productText.includes('unavailable') ||
                    productHtml.includes('out-of-stock') ||
                    productHtml.includes('sold-out') ||
                    productHtml.includes('unavailable') ||
                    outOfStockSelectors.length > 0
                ) {

                    outOfStockProducts.push(product);

                }

                // ON HOLD / RESERVED
                else if (
                    productText.includes('on hold') ||
                    productText.includes('reserved') ||
                    productText.includes('pre-order') ||
                    productHtml.includes('on-hold') ||
                    productHtml.includes('reserved') ||
                    onHoldSelectors.length > 0
                ) {

                    onHoldProducts.push(product);

                }

                // AVAILABLE
                else {

                    availableProducts.push(product);

                }

            });


            // Remove only products belonging to this container
            productContainers.forEach(product => {

                if (product.parentNode === parentContainer) {
                    product.remove();
                }

            });


            // Available → On Hold → Out of Stock
            const sortedProducts = [
                ...availableProducts,
                ...onHoldProducts,
                ...outOfStockProducts
            ];


            // Re-append sorted products
            sortedProducts.forEach(product => {
                parentContainer.appendChild(product);
            });


            console.log(
                `Sorted: ${availableProducts.length} available, ` +
                `${onHoldProducts.length} on hold, ` +
                `${outOfStockProducts.length} out of stock`
            );


            // Keep ad injection working on search pages too
            if (typeof injectAdCards === 'function') {
                injectAdCards(parentContainer);
            }

        }

    }, 1000);
}
// 9. SEARCH BAR FUNCTIONALITY
function initSearch() {
    console.log('Initializing search functionality...');
    
    const searchBtn = document.querySelector('.search-btn-mb');
    const searchPopup = document.getElementById('serches');
    const closeSearchBtn = document.querySelector('.search-hidden .search-btn.close-search');
    const headerSearch = document.querySelector('.header-middle .ctsmindex');
    const headerCloseBtn = document.querySelector('.ctsmindexclose');
    const mainSearchForm = document.querySelector('form.navbar-form[action="/search"]');
    const searchInput = document.getElementById('instant-search');
    
    if (searchBtn && searchPopup) {
        searchBtn.replaceWith(searchBtn.cloneNode(true));
        const freshSearchBtn = document.querySelector('.search-btn-mb');
        
        freshSearchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (searchPopup.classList.contains('active')) {
                searchPopup.style.transform = 'translateY(-100%)';
                searchPopup.style.opacity = '0';
                setTimeout(() => {
                    searchPopup.classList.remove('active');
                    searchPopup.style.transform = '';
                    searchPopup.style.opacity = '';
                }, 300);
            } else {
                searchPopup.classList.add('active');
                requestAnimationFrame(() => {
                    searchPopup.style.transform = 'translateY(0)';
                    searchPopup.style.opacity = '1';
                    
                    const popupInput = searchPopup.querySelector('input[type="text"]');
                    if (popupInput) {
                        setTimeout(() => {
                            popupInput.focus();
                            popupInput.select();
                        }, 100);
                    }
                });
            }
        });
    }
    
    if (closeSearchBtn && searchPopup) {
        closeSearchBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            searchPopup.style.transform = 'translateY(-100%)';
            searchPopup.style.opacity = '0';
            setTimeout(() => {
                searchPopup.classList.remove('active');
                searchPopup.style.transform = '';
                searchPopup.style.opacity = '';
            }, 300);
        });
    }
    
    if (searchBtn && headerSearch) {
        searchBtn.addEventListener('click', function(e) {
            if (window.innerWidth > 768) {
                headerSearch.classList.add('active');
                setTimeout(() => {
                    const headerInput = headerSearch.querySelector('input[type="text"]');
                    if (headerInput) {
                        headerInput.focus();
                        headerInput.select();
                    }
                }, 100);
            }
        });
    }
    
    if (headerCloseBtn && headerSearch) {
        headerCloseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            headerSearch.classList.remove('active');
        });
    }
    
    document.addEventListener('click', function(e) {
        if (searchPopup && searchPopup.classList.contains('active')) {
            const isClickInside = searchPopup.contains(e.target);
            const isClickOnBtn = searchBtn && searchBtn.contains(e.target);
            
            if (!isClickInside && !isClickOnBtn) {
                searchPopup.style.transform = 'translateY(-100%)';
                searchPopup.style.opacity = '0';
                setTimeout(() => {
                    searchPopup.classList.remove('active');
                    searchPopup.style.transform = '';
                    searchPopup.style.opacity = '';
                }, 300);
            }
        }
        
        if (headerSearch && headerSearch.classList.contains('active') && window.innerWidth > 768) {
            const isClickInsideHeader = headerSearch.contains(e.target);
            const isClickOnSearchBtn = searchBtn && searchBtn.contains(e.target);
            
            if (!isClickInsideHeader && !isClickOnSearchBtn) {
                headerSearch.classList.remove('active');
            }
        }
    });
    
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            if (searchPopup && searchPopup.classList.contains('active')) {
                searchPopup.style.transform = 'translateY(-100%)';
                searchPopup.style.opacity = '0';
                setTimeout(() => {
                    searchPopup.classList.remove('active');
                    searchPopup.style.transform = '';
                    searchPopup.style.opacity = '';
                }, 300);
            }
            
            if (headerSearch && headerSearch.classList.contains('active')) {
                headerSearch.classList.remove('active');
            }
        }
    });
    
    if (mainSearchForm) {
        const newForm = mainSearchForm.cloneNode(true);
        mainSearchForm.parentNode.replaceChild(newForm, mainSearchForm);
        
        newForm.addEventListener('submit', function(e) {
            const input = this.querySelector('#instant-search');
            if (!input || !input.value.trim()) {
                e.preventDefault();
                console.log('Empty search prevented');
                return false;
            }
            console.log('Form submitting with:', input.value);
            return true;
        });
        
        const formSearchBtn = newForm.querySelector('.search-btn');
        if (formSearchBtn) {
            formSearchBtn.addEventListener('click', function(e) {
                console.log('Search button in form clicked');
            });
        }
    }
    
    if (searchInput) {
        searchInput.removeAttribute('disabled');
        searchInput.addEventListener('focus', function() {
            this.removeAttribute('readonly');
        });
    }
    
    console.log('Search functionality initialized successfully');
}

// 10. SAME-DAY DELIVERY
window.SameDayDelivery = (function () {
    const USER_CITY_KEYS = ['delivery_city','delivery_region','geo_city','selected_city'];
    let isInitialized = false;

    function getCookie(name) {
        const match = document.cookie.match(
            new RegExp('(?:^|; )' + name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
        );
        return match ? decodeURIComponent(match[1]) : null;
    }

    function normalizeUserRegion(str) {
        if (!str) return null;
        const s = String(str).toLowerCase().trim();

        if (s.includes('delhi') || s.includes('ncr') ||
            s.includes('gurgaon') || s.includes('gurugram') ||
            s.includes('noida') || s.includes('greater noida') ||
            s.includes('ghaziabad') || s.includes('faridabad')) {
            return 'delhi_ncr';
        }

        if (s.includes('mumbai') || s.includes('bombay') ||
            s.includes('navi mumbai') || s.includes('thane') ||
            s.includes('mumbai suburban') || s.includes('greater mumbai') ||
            s.includes('maharashtra')) {
            return 'mumbai';
        }

        return null;
    }

    function getUserRegionFromStorage() {
        for (let i = 0; i < USER_CITY_KEYS.length; i++) {
            try {
                const v = localStorage.getItem(USER_CITY_KEYS[i]) || getCookie(USER_CITY_KEYS[i]);
                const n = normalizeUserRegion(v);
                if (n) return n;
            } catch(e) {}
        }
        return null;
    }

    async function detectUserRegion() {
        let n = getUserRegionFromStorage();
        if (n) return n;

        try {
            const cache = JSON.parse(localStorage.getItem('__geo_cache__') || 'null');
            if (cache && Date.now() - cache.t < 86400000) {
                const nc = normalizeUserRegion((cache.city || '') + ' ' + (cache.region || ''));
                if (nc) return nc;
            }
        } catch(e) {}

        let city = null, region = null;

        try {
            const r = await fetch('https://ipapi.co/json/');
            if (r.ok) { 
                const j = await r.json(); 
                city = j.city; 
                region = j.region; 
            }
        } catch(e) {}

        if (!city && !region) {
            try {
                const r2 = await fetch('https://ipinfo.io/json', { mode: 'cors' });
                if (r2.ok) { 
                    const j2 = await r2.json(); 
                    city = j2.city; 
                    region = j2.region; 
                }
            } catch(e) {}
        }

        if (city || region) {
            try {
                localStorage.setItem('__geo_cache__', JSON.stringify({
                    t: Date.now(), 
                    city: city, 
                    region: region
                }));
            } catch(e) {}
            return normalizeUserRegion((city || '') + ' ' + (region || ''));
        }

        return null;
    }

    function productChoiceToRegion(choice) {
        if (!choice) return null;
        const c = String(choice).toLowerCase().trim();

        if (c === 'inventory' || c.indexOf('in transit') === 0) return null;
        if (c === 'delhi headquarter' || c === 'delhi store') return 'delhi_ncr';
        if (c === 'mumbai store') return 'mumbai';

        return null;
    }

    function labelForRegion(region) {
        return region === 'delhi_ncr' ? 'Delhi NCR' : (region === 'mumbai' ? 'Mumbai' : '');
    }

    function updateUI(userRegion) {
        if (!userRegion) return;
        
        requestAnimationFrame(() => {
            document.querySelectorAll('[data-same-day-inline]').forEach(function(el) {
                const raw = el.getAttribute('data-product-location') || '';
                const pRegion = productChoiceToRegion(raw);
                const show = pRegion && (pRegion === userRegion);

                if (show) {
                    el.textContent = 'Same-day delivery in ' + labelForRegion(userRegion);
                    el.style.opacity = '1';
                    el.style.visibility = 'visible';
                    el.setAttribute('aria-hidden', 'false');
                } else {
                    el.style.opacity = '0';
                    el.style.visibility = 'hidden';
                    el.setAttribute('aria-hidden', 'true');
                }
            });

            document.querySelectorAll('[data-same-day-badge]').forEach(function(badge) {
                const card = badge.closest('[data-product-location]');
                if (!card) return;
                const raw = card.getAttribute('data-product-location') || '';
                const pRegion = productChoiceToRegion(raw);
                const show = pRegion && (pRegion === userRegion);
                
                badge.style.transform = show ? 'scale(1)' : 'scale(0)';
                badge.style.opacity = show ? '1' : '0';
                badge.style.pointerEvents = show ? 'auto' : 'none';
                badge.setAttribute('aria-hidden', show ? 'false' : 'true');
            });
        });
    }

    async function init() {
        if (isInitialized) return;
        isInitialized = true;
        
        if ('requestIdleCallback' in window) {
            requestIdleCallback(async () => {
                const userRegion = await detectUserRegion();
                updateUI(userRegion);
            }, { timeout: 3000 });
        } else {
            setTimeout(async () => {
                const userRegion = await detectUserRegion();
                updateUI(userRegion);
            }, 1000);
        }
    }

    return { init, detectUserRegion, updateUI };
})();

// 11. CACHE CLEARING
(function() {
    'use strict';
    
    const CONFIG = {
        VERSION: '2024.01.15.03',
        ENABLE_LOCAL_STORAGE_CLEAR: true,
        ENABLE_SESSION_STORAGE_CLEAR: true,
        ENABLE_SERVICE_WORKER_CLEAR: false,
        ENABLE_CACHE_API_CLEAR: false,
        ENABLE_ASSET_RELOAD: false,
        ENABLE_PAGE_RELOAD: false,
        SHOW_UPDATE_NOTIFICATION: true,
        NOTIFICATION_DURATION: 5000,
        EXCLUDED_PAGES: ['/checkout', '/cart', '/account', '/apps/', '/admin/'],
        DEBUG: false
    };
    
    function clearWebsiteCache() {
        const storedVersion = localStorage.getItem('theme_version');
        const isVersionChanged = storedVersion !== CONFIG.VERSION;
        
        if (isVersionChanged) {
            if ('requestIdleCallback' in window) {
                requestIdleCallback(() => {
                    executeCacheClearing();
                    showUpdateNotification();
                }, { timeout: 2000 });
            } else {
                setTimeout(() => {
                    executeCacheClearing();
                    showUpdateNotification();
                }, 1000);
            }
        }
        
        localStorage.setItem('theme_version', CONFIG.VERSION);
    }
    
    function executeCacheClearing() {
        try {
            if (CONFIG.ENABLE_LOCAL_STORAGE_CLEAR) {
                clearLocalStorage();
            }
            
            if (CONFIG.ENABLE_SESSION_STORAGE_CLEAR) {
                clearSessionStorage();
            }
        } catch (error) {
            console.error('[Cache Clear] Error:', error);
        }
    }
    
    function clearLocalStorage() {
        try {
            const itemsToKeep = ['theme_version', 'cart', 'customer', 'wishlist', 'recently_viewed', '__geo_cache__'];
            const itemsToClear = [];
            
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (!itemsToKeep.includes(key)) {
                    itemsToClear.push(key);
                }
            }
            
            const clearBatch = (index = 0) => {
                if (index < itemsToClear.length) {
                    localStorage.removeItem(itemsToClear[index]);
                    if (index % 5 === 0) {
                        setTimeout(() => clearBatch(index + 1), 0);
                    } else {
                        clearBatch(index + 1);
                    }
                }
            };
            
            clearBatch();
        } catch (e) {
            // Silent fail
        }
    }
    
    function clearSessionStorage() {
        try {
            const keepKeys = ['temp_session'];
            for (let key in sessionStorage) {
                if (!keepKeys.includes(key)) {
                    sessionStorage.removeItem(key);
                }
            }
        } catch (e) {
            // Silent fail
        }
    }
    
    function showUpdateNotification() {
        if (!CONFIG.SHOW_UPDATE_NOTIFICATION) return;
        
        try {
            const notification = document.createElement('div');
            notification.id = 'cache-clear-notification';
            notification.style.cssText = `
                position: fixed;
                bottom: 20px;
                right: 20px;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                padding: 15px 25px;
                border-radius: 12px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                z-index: 999999;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                font-size: 14px;
                max-width: 300px;
                backdrop-filter: blur(10px);
                border: 1px solid rgba(255,255,255,0.2);
                opacity: 0;
                transform: translateY(100px);
                transition: opacity 0.5s ease, transform 0.5s ease;
                pointer-events: none;
            `;
        
            
            document.body.appendChild(notification);
            
            requestAnimationFrame(() => {
                notification.style.opacity = '1';
                notification.style.transform = 'translateY(0)';
            });
            
            setTimeout(() => {
                notification.style.opacity = '0';
                notification.style.transform = 'translateY(100px)';
                setTimeout(() => notification.remove(), 500);
            }, CONFIG.NOTIFICATION_DURATION);
            
        } catch (e) {
            // Silent fail
        }
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            if ('requestIdleCallback' in window) {
                requestIdleCallback(clearWebsiteCache, { timeout: 3000 });
            } else {
                setTimeout(clearWebsiteCache, 1000);
            }
        });
    } else {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(clearWebsiteCache, { timeout: 3000 });
        } else {
            setTimeout(clearWebsiteCache, 1000);
        }
    }
    
    window.clearWebsiteCache = clearWebsiteCache;
    window.forceCacheClear = function() {
        localStorage.removeItem('theme_version');
        clearWebsiteCache();
    };
})();

// 13. IMAGE LOADING OPTIMIZATION
function optimizeImageLoading() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
        if (img.complete) {
            img.setAttribute('data-loaded', 'true');
        } else {
            img.addEventListener('load', function() {
                this.setAttribute('data-loaded', 'true');
            });
            img.addEventListener('error', function() {
                this.style.opacity = '1';
            });
        }
    });
}

// 14. MAIN INITIALIZATION
document.addEventListener('DOMContentLoaded', function() {
    initOfferCalculator();
    initReserveButton();
    initMobileSlider();
    initOfferButton();
    initSearch();
    initVideoFunctionality();
    optimizeImageLoading();
    initSmartPagination();
    sortProductsAndInjectAds(); // ✅ Sorts products and injects ads
    
    if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
            if (window.SameDayDelivery && typeof window.SameDayDelivery.init === 'function') {
                window.SameDayDelivery.init();
            }
        }, { timeout: 5000 });
    } else {
        setTimeout(() => {
            if (window.SameDayDelivery && typeof window.SameDayDelivery.init === 'function') {
                window.SameDayDelivery.init();
            }
        }, 2000);
    }
    
    if ('PerformanceObserver' in window && 'LayoutShift' in window) {
        const observer = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (entry.hadRecentInput) return;
                if (entry.value > 0.01) {
                    console.warn('CLS detected:', entry);
                }
            }
        });
        observer.observe({ type: 'layout-shift', buffered: true });
    }
});

window.addEventListener('load', function() {
    const images = document.querySelectorAll('.paira-product-image img');
    images.forEach(img => {
        if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
            if (img.naturalWidth && img.naturalHeight) {
                img.setAttribute('width', img.naturalWidth);
                img.setAttribute('height', img.naturalHeight);
            }
        }
    });
    
    setTimeout(() => {
        initSmartPagination();
        sortProductsAndInjectAds(); // Re-run after full load for safety
    }, 2000);
});

// Clean conflicting handlers
jQuery(document).off('click', '.search-btn-mb');
jQuery(document).off('click', '.search-hidden .search-btn.close-search');
/* ============================================= */
/*  VIEW ALL RESULTS – HREF UPDATER ONLY         */
/* ============================================= */
(function() {
  'use strict';

  const SEARCH_INPUT_SELECTOR = '.js-instant-search-input, input[name="q"], #instant-search';
  const VIEW_ALL_LINK_SELECTOR = '.instant-search-data .view-all-results .js-view-all-link';

  function getSearchQuery() {
    const input = document.querySelector(SEARCH_INPUT_SELECTOR);
    return input ? input.value.trim() : '';
  }

  function updateViewAllLink() {
    const query = getSearchQuery();
    const links = document.querySelectorAll(VIEW_ALL_LINK_SELECTOR);

    links.forEach(link => {
      // Update href
      link.href = query ? `/search?q=${encodeURIComponent(query)}&type=product` : '#';

      // Show/hide the parent container
      const container = link.closest('.view-all-results');
      if (container) {
        container.style.display = query ? 'block' : 'none';
      }
    });
  }

  // Debounce helper
  let debounceTimer;
  function debouncedUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateViewAllLink, 100);
  }

  // Event listeners
  document.addEventListener('input', e => {
    if (e.target.matches(SEARCH_INPUT_SELECTOR)) debouncedUpdate();
  });

  document.addEventListener('focusin', e => {
    if (e.target.matches(SEARCH_INPUT_SELECTOR)) debouncedUpdate();
  });

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateViewAllLink);
  } else {
    updateViewAllLink();
  }
})();

/*  Customer who bought header in mobile fix overlapping with product grid on cart page       */

(function () {

  function fixCartRelatedProductsHeading() {

    // MOBILE ONLY
    if (window.innerWidth > 767) return;

    // Find ONLY this specific heading
    const heading = [...document.querySelectorAll('.heading')]
      .find(function (el) {
        const text = el.textContent.trim();

        return text.includes(
          'Customers who bought this item also bought'
        );
      });

    // If this heading doesn't exist, do absolutely nothing
    if (!heading) return;

    // Make sure it is actually inside the cart page
    const isCartPage =
      document.body.classList.contains('template-cart') ||
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('[action="/cart"]');

    if (!isCartPage) return;

    const slider = heading.nextElementSibling;

    // -------------------------
    // FIX HEADING
    // -------------------------

    heading.style.setProperty(
      'display',
      'block',
      'important'
    );

    heading.style.setProperty(
      'height',
      'auto',
      'important'
    );

    heading.style.setProperty(
      'min-height',
      '0',
      'important'
    );

    heading.style.setProperty(
      'margin-bottom',
      '25px',
      'important'
    );

    heading.style.setProperty(
      'position',
      'relative',
      'important'
    );

    heading.style.setProperty(
      'z-index',
      '10',
      'important'
    );


    // -------------------------
    // FIX HEADING TEXT
    // -------------------------

    const title = heading.querySelector('h2');

    if (title) {

      title.style.setProperty(
        'display',
        'block',
        'important'
      );

      title.style.setProperty(
        'height',
        'auto',
        'important'
      );

      title.style.setProperty(
        'line-height',
        '1.3',
        'important'
      );

      title.style.setProperty(
        'margin',
        '0',
        'important'
      );

    }


    // -------------------------
    // FIX PRODUCT GRID
    // -------------------------

    if (slider) {

      slider.style.setProperty(
        'position',
        'relative',
        'important'
      );

      slider.style.setProperty(
        'margin-top',
        '25px',
        'important'
      );

      slider.style.setProperty(
        'z-index',
        '1',
        'important'
      );

    }

  }


  // Run after page loads
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      fixCartRelatedProductsHeading
    );

  } else {

    fixCartRelatedProductsHeading();

  }


  // Swiper/theme initialization happens after page load
  setTimeout(fixCartRelatedProductsHeading, 300);
  setTimeout(fixCartRelatedProductsHeading, 1000);

})();

/* =========================================
   COMPACT DOT SLIDER PAGINATION
========================================= */

document.addEventListener('DOMContentLoaded', function () {

  const pagination = document.querySelector('.pagination-slider');

  if (!pagination) return;

  const range = pagination.querySelector('.pagination-range');
  const dots = pagination.querySelectorAll('.pagination-dot');
  const prevButton = pagination.querySelector('.pagination-prev');
  const nextButton = pagination.querySelector('.pagination-next');


  /* =========================================
     GO TO URL
  ========================================= */

  function goToUrl(url) {

    if (!url) return;

    window.location.href = url;

  }


  /* =========================================
     GO TO PAGE
     Keeps existing filters/sorting
  ========================================= */

  function goToPage(page) {

    const pageNumber = parseInt(page, 10);

    if (!pageNumber || pageNumber < 1) return;

    const url = new URL(window.location.href);

    url.searchParams.set('page', pageNumber);

    window.location.href = url.toString();

  }


  /* =========================================
     PREVIOUS BUTTON
  ========================================= */

  if (prevButton) {

    prevButton.addEventListener('click', function () {

      if (this.disabled) return;

      const url = this.getAttribute('data-url');

      if (url) {
        goToUrl(url);
      }

    });

  }


  /* =========================================
     NEXT BUTTON
  ========================================= */

  if (nextButton) {

    nextButton.addEventListener('click', function () {

      if (this.disabled) return;

      const url = this.getAttribute('data-url');

      if (url) {
        goToUrl(url);
      }

    });

  }


  /* =========================================
     DOT CLICK
  ========================================= */

  dots.forEach(function (dot) {

    dot.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      const page = this.getAttribute('data-page');

      if (page) {
        goToPage(page);
      }

    });

  });


  /* =========================================
     SLIDER DRAG
  ========================================= */

  if (range) {

    range.addEventListener('change', function () {

      goToPage(this.value);

    });

  }

});
/* ==========================================================
   DESKTOP FILTER ACTIONS — FLOAT AT VISIBLE SIDEBAR BOTTOM
   ========================================================== */
(function () {

  if (window.innerWidth < 992) return;

  let mouseX = 0;
  let mouseY = 0;
  let activeSidebar = null;

  function getSidebar() {
    return document.querySelector('#sidebar.sidebar');
  }

  function getActions() {
    const sidebar = getSidebar();
    if (!sidebar) return null;

    return sidebar.querySelector('.filter-actions');
  }

  function isInsideSidebar(sidebar) {
    if (!sidebar) return false;

    const rect = sidebar.getBoundingClientRect();

    return (
      mouseX >= rect.left &&
      mouseX <= rect.right &&
      mouseY >= rect.top &&
      mouseY <= rect.bottom
    );
  }
function positionActions(sidebar, actions) {

  const rect = sidebar.getBoundingClientRect();

  /*
   * Keep the buttons visually INSIDE the visible sidebar.
   * The buttons are still fixed so they stay at the visible
   * bottom while the sidebar itself scrolls.
   */
  const actionsHeight = actions.offsetHeight || 55;

  let topPosition = rect.bottom - actionsHeight;

  /*
   * Never allow the buttons below the visible sidebar.
   */
  topPosition = Math.min(
    topPosition,
    window.innerHeight - actionsHeight
  );

  /*
   * Never allow the buttons above the sidebar.
   */
  topPosition = Math.max(
    topPosition,
    rect.top
  );

  /*
   * If the sidebar is no longer visible, hide the buttons.
   */
  if (
    rect.bottom <= rect.top ||
    rect.bottom < 0 ||
    rect.top > window.innerHeight
  ) {
    hideActions(actions);
    return;
  }

  actions.style.setProperty(
    'position',
    'fixed',
    'important'
  );

  actions.style.setProperty(
    'left',
    rect.left + 'px',
    'important'
  );

  actions.style.setProperty(
    'top',
    topPosition + 'px',
    'important'
  );

  actions.style.setProperty(
    'bottom',
    'auto',
    'important'
  );

  actions.style.setProperty(
    'width',
    rect.width + 'px',
    'important'
  );

  actions.style.setProperty(
    'z-index',
    '999999',
    'important'
  );

  actions.style.setProperty(
    'opacity',
    '1',
    'important'
  );

  actions.style.setProperty(
    'visibility',
    'visible',
    'important'
  );

  actions.style.setProperty(
    'pointer-events',
    'auto',
    'important'
  );

  actions.style.setProperty(
    'background',
    '#fff',
    'important'
  );
}

  function hideActions(actions) {

    if (!actions) return;

    actions.style.setProperty(
      'opacity',
      '0',
      'important'
    );

    actions.style.setProperty(
      'visibility',
      'hidden',
      'important'
    );

    actions.style.setProperty(
      'pointer-events',
      'none',
      'important'
    );
  }

  function updatePosition() {

    const sidebar = getSidebar();
    const actions = getActions();

    if (!sidebar || !actions) return;

    if (activeSidebar && isInsideSidebar(sidebar)) {
      positionActions(sidebar, actions);
    } else {
      hideActions(actions);
    }
  }

  function init() {

    const sidebar = getSidebar();
    const actions = getActions();

    if (!sidebar || !actions) return;

    hideActions(actions);

    document.addEventListener(
      'pointermove',
      function (e) {

        mouseX = e.clientX;
        mouseY = e.clientY;

        if (isInsideSidebar(sidebar)) {

          activeSidebar = sidebar;

          positionActions(sidebar, actions);

        } else {

          activeSidebar = null;

          hideActions(actions);

        }

      },
      true
    );

    window.addEventListener(
      'scroll',
      function () {

        if (activeSidebar && isInsideSidebar(sidebar)) {
          positionActions(sidebar, actions);
        }

      },
      true
    );

    window.addEventListener(
      'resize',
      function () {

        if (window.innerWidth < 992) {
          hideActions(actions);
          return;
        }

        updatePosition();

      },
      true
    );

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );

  } else {

    init();

  }

})();

/* =========================================================
   CC — COMPACT LIVE SEARCH FIX
   ========================================================= */
(function () {
  'use strict';

  const INPUT = '.search-frm input#instant-search, .search-frm input[name="q"]';
  const BOX = '.instant-search-data';
  const TREND = '.smart-search-trending';
  const VIEW = '.view-all-results .js-view-all-link';

  const state = new WeakMap();
  let userOpenedSearch = false;

  function root() {
    return window.Shopify?.routes?.root || '/';
  }

  function box(input) {
    return input.closest('.search-frm')?.querySelector(BOX) ||
           document.querySelector(BOX);
  }

  function trend(input) {
    return input.closest('.search-frm')?.querySelector(TREND) ||
           document.querySelector(TREND);
  }

  function hideAll(input) {
    const b = box(input), t = trend(input);
    if (b) b.style.display = 'none';
    if (t) t.style.display = 'none';
  }

  function showTrend(input) {
    const b = box(input), t = trend(input);
    if (b) b.style.display = 'none';
    if (t) t.style.display = 'block';
  }

  function showResults(input) {
    const b = box(input), t = trend(input);
    if (t) t.style.display = 'none';
    if (b) {
      b.style.display = 'block';
      b.style.visibility = 'visible';
      b.style.opacity = '1';
    }
  }

  function updateView(input, q) {
    const scope = input.closest('.search-frm') || document;

    scope.querySelectorAll(VIEW).forEach(function (a) {
      const wrap = a.closest('.view-all-results');

      if (q) {
        a.href = root() + 'search?q=' +
          encodeURIComponent(q) + '&type=product';
        if (wrap) wrap.style.display = 'block';
      } else {
        a.href = '#';
        if (wrap) wrap.style.display = 'none';
      }
    });
  }

  function render(input, products) {
    const b = box(input);
    if (!b) return;

    const ul = b.querySelector('ul');
    if (!ul) return;

    if (!products.length) {
      ul.innerHTML =
        '<li class="instant-search-no-results">No matching products found</li>';
      return;
    }

    ul.innerHTML = products.map(function (p) {
      const image =
        p.featured_image?.url ||
        p.image ||
        '';

      const url =
        p.url ||
        (p.handle ? '/products/' + p.handle : '#');

      const price =
        window.Shopify?.formatMoney
          ? Shopify.formatMoney(
              Math.round(parseFloat(p.price || 0) * 100),
              window._?.money_format || ''
            )
          : 'Rs. ' +
            Number(p.price || 0).toLocaleString('en-IN');

      return `
        <li>
          <a href="${url}">
            <div class="pull-left search-im">
              <img src="${image}" alt="">
            </div>
            <div class="pull-left search-desc">
              <p class="product-title">${p.title || ''}</p>
              <p class="margin-bottom-0">
                <span class="money">${price}</span>
              </p>
            </div>
          </a>
        </li>`;
    }).join('');
  }

  async function search(input, q) {
    let s = state.get(input);

    if (!s) {
      s = { timer: null, controller: null, id: 0 };
      state.set(input, s);
    }

    clearTimeout(s.timer);

    if (s.controller) {
      try { s.controller.abort(); } catch (e) {}
    }

    s.id++;
    const id = s.id;

    if (!q) {
      hideAll(input);
      return;
    }

    showResults(input);
    updateView(input, q);

    s.timer = setTimeout(async function () {
      try {
        s.controller = new AbortController();

        const params = new URLSearchParams({
          q: q,
          'resources[type]': 'product',
          'resources[limit]': '10',
          'resources[limit_scope]': 'all',
          'resources[options][unavailable_products]': 'last'
        });

        const response = await fetch(
          root() + 'search/suggest.json?' + params,
          {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: s.controller.signal
          }
        );

        if (!response.ok) throw new Error(response.status);

        const data = await response.json();

        if (id !== s.id) return;

        render(
          input,
          data?.resources?.results?.products || []
        );

      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error('[CC Search]', e);
        }
      }
    }, 120);
  }

  function bind(input) {
    if (input.dataset.ccSearchBound) return;
    input.dataset.ccSearchBound = '1';

    /* IMPORTANT: block automatic/programmatic focus */
    input.addEventListener('focus', function () {
      if (!userOpenedSearch) {
        hideAll(input);
        return;
      }

      const q = input.value.trim();
      q ? showResults(input) : showTrend(input);
    }, true);

    input.addEventListener('pointerdown', function () {
      userOpenedSearch = true;
    });

    input.addEventListener('click', function () {
      userOpenedSearch = true;

      const q = input.value.trim();
      q ? showResults(input) : showTrend(input);
    });

    input.addEventListener('input', function () {
      userOpenedSearch = true;

      const q = input.value.trim();

      updateView(input, q);

      if (!q) {
        showTrend(input);
        return;
      }

      search(input, q);
    });
  }

  function init() {
    /*
     * Kill the old Paira delegated live-search handler.
     */
    if (window.jQuery) {
      jQuery(document).off('input', '#instant-search');
    }

    /*
     * FORCE CLOSED on page load.
     */
    document.querySelectorAll(BOX + ',' + TREND).forEach(function (el) {
      el.style.display = 'none';
    });

    document.querySelectorAll(INPUT).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* =========================================================
   CC — DESKTOP SEARCH CLOSE BUTTON ONLY
   No mobile functionality
   ========================================================= */
(function () {
  'use strict';

  var DESKTOP = 768;

  var INPUT =
    '.search-frm input#instant-search, .search-frm input[name="q"]';

  var PANELS = [
    '.instant-search-data',
    '.smart-search-trending'
  ];

  var closeButton = null;

  function isDesktop() {
    return window.innerWidth > DESKTOP;
  }

  function getVisiblePanel() {
    if (!isDesktop()) return null;

    for (var i = 0; i < PANELS.length; i++) {
      var elements = document.querySelectorAll(PANELS[i]);

      for (var j = 0; j < elements.length; j++) {
        var el = elements[j];
        var style = window.getComputedStyle(el);

        if (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          parseFloat(style.opacity || '1') > 0
        ) {
          return el;
        }
      }
    }

    return null;
  }

  function createCloseButton() {
    if (closeButton || !isDesktop()) return;

    closeButton = document.createElement('button');

    closeButton.type = 'button';
    closeButton.className = 'cc-desktop-search-close';
    closeButton.setAttribute(
      'aria-label',
      'Close search'
    );

    closeButton.innerHTML = '&times;';

    closeButton.style.cssText = [
      'position:fixed',
      'display:none',
      'width:22px',
      'height:22px',
      'padding:0',
      'margin:0',
      'border:1px solid #d5d5d5',
      'border-radius:50%',
      'background:#fff',
      'color:#111',
      'font-family:Arial,sans-serif',
      'font-size:18px',
      'font-weight:400',
      'line-height:19px',
      'text-align:center',
      'cursor:pointer',
      'z-index:2147483647',
      'box-sizing:border-box',
      'box-shadow:0 1px 5px rgba(0,0,0,.16)'
    ].join(';');

    document.body.appendChild(closeButton);

    closeButton.addEventListener(
      'mouseenter',
      function () {
        closeButton.style.background = '#111';
        closeButton.style.color = '#fff';
        closeButton.style.borderColor = '#111';
      }
    );

    closeButton.addEventListener(
      'mouseleave',
      function () {
        closeButton.style.background = '#fff';
        closeButton.style.color = '#111';
        closeButton.style.borderColor = '#d5d5d5';
      }
    );

    closeButton.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        document
          .querySelectorAll(
            '.instant-search-data, .smart-search-trending'
          )
          .forEach(function (el) {
            el.style.display = 'none';
          });

        var input = document.querySelector(INPUT);

        if (input) {
          input.blur();
        }

        closeButton.style.display = 'none';
      }
    );
  }

  function positionCloseButton() {
    if (!isDesktop()) {
      if (closeButton) {
        closeButton.style.display = 'none';
      }
      return;
    }

    if (!closeButton) {
      createCloseButton();
    }

    var panel = getVisiblePanel();

    if (!panel) {
      closeButton.style.display = 'none';
      return;
    }

    var rect = panel.getBoundingClientRect();

    closeButton.style.left =
      Math.round(rect.right - 11) + 'px';

    closeButton.style.top =
      Math.round(rect.top - 11) + 'px';

    closeButton.style.display = 'block';
  }

  function refresh() {
    if (!isDesktop()) return;

    setTimeout(
      positionCloseButton,
      20
    );
  }

  function init() {
    /*
     * Absolutely nothing on mobile/tablet.
     */
    if (!isDesktop()) return;

    createCloseButton();

    document.addEventListener(
      'focusin',
      function (e) {
        if (
          isDesktop() &&
          e.target &&
          e.target.matches &&
          e.target.matches(INPUT)
        ) {
          refresh();
        }
      }
    );

    document.addEventListener(
      'input',
      function (e) {
        if (
          isDesktop() &&
          e.target &&
          e.target.matches &&
          e.target.matches(INPUT)
        ) {
          refresh();
        }
      }
    );

    document.addEventListener(
      'click',
      function (e) {
        if (!isDesktop()) return;

        if (
          e.target &&
          e.target.closest &&
          e.target.closest(INPUT)
        ) {
          refresh();
        }
      },
      true
    );

    window.addEventListener(
      'resize',
      function () {
        if (isDesktop()) {
          createCloseButton();
          positionCloseButton();
        } else if (closeButton) {
          closeButton.style.display = 'none';
        }
      }
    );

    window.addEventListener(
      'scroll',
      function () {
        if (isDesktop()) {
          positionCloseButton();
        }
      },
      true
    );

    /*
     * Check search state only on desktop.
     */
    setInterval(function () {
      if (!isDesktop()) {
        if (closeButton) {
          closeButton.style.display = 'none';
        }
        return;
      }

      positionCloseButton();
    }, 300);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("view-similar-btn");
  const modal = document.getElementById("similar-products-modal");
  const grid = document.getElementById("similar-products-grid");
  const close = document.querySelector(".similar-products-close");
  const overlay = document.querySelector(".similar-products-overlay");

  if (!btn || !modal || !grid) return;

  /* Move popup directly under body */
  document.body.appendChild(modal);

  const type = btn.dataset.productType || "";
  const vendor = btn.dataset.productVendor || "";
  const currentId = btn.dataset.productId || "";

  /* Safely format Shopify field-specific search values */
  function searchPhrase(value) {
    return `"${String(value)
      .replace(/\\/g, "\\\\")
      .replace(/"/g, '\\"')}"`;
  }

  /* Fetch products from Shopify predictive search */
  async function fetchProducts(query) {
    const params = new URLSearchParams();

    params.set("q", query);
    params.set("resources[type]", "product");
    params.set("resources[limit]", "20");
    params.set(
      "resources[options][unavailable_products]",
      "hide"
    );

    const response = await fetch(
      `/search/suggest.json?${params.toString()}`
    );

    if (!response.ok) {
      throw new Error("Similar product search failed");
    }

    const data = await response.json();

    return data?.resources?.results?.products || [];
  }

  /* Exclude current product and confirm same vendor */
  function excludeCurrentProduct(products) {
    return products.filter(
      product =>
        String(product.id) !== String(currentId)
    );
  }

  function renderProducts(products) {
    if (!products.length) {
      grid.innerHTML =
        '<div class="similar-products-empty">No similar products are currently available.</div>';
      return;
    }

    grid.innerHTML = products.slice(0, 8).map(product => `
      <a href="${product.url}" class="similar-product-card">

        <div class="similar-product-image">
          ${
            product.image
              ? `<img src="${product.image}" alt="${escapeHTML(product.title)}" loading="lazy">`
              : ""
          }
        </div>

        <div class="similar-product-info">
          ${
            product.vendor
              ? `<div class="similar-product-brand">${escapeHTML(product.vendor)}</div>`
              : ""
          }

          <div class="similar-product-title">
            ${escapeHTML(product.title)}
          </div>

          ${
            product.price
              ? `<div class="similar-product-price">${escapeHTML(product.price)}</div>`
              : ""
          }
        </div>

      </a>
    `).join("");
  }

  btn.addEventListener("click", async () => {
    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    grid.innerHTML =
      '<div class="similar-products-loading">Loading similar products...</div>';

    try {
      let similar = [];

      /*
       * PRIORITY 1:
       * Same vendor AND same product type.
       */
      if (vendor.trim() && type.trim()) {
        const vendorQuery =
          `vendor:${searchPhrase(vendor)} product_type:${searchPhrase(type)}`;

        const vendorProducts = await fetchProducts(vendorQuery);

        similar = excludeCurrentProduct(vendorProducts).filter(
          product =>
            String(product.vendor || "").trim().toLowerCase() ===
            vendor.trim().toLowerCase()
        );
      }

      /*
       * PRIORITY 2:
       * If no same-vendor products are available,
       * use the existing product-type search.
       */
      if (similar.length === 0 && type.trim()) {
        const typeQuery =
          `product_type:${searchPhrase(type)}`;

        const typeProducts = await fetchProducts(typeQuery);

        similar = excludeCurrentProduct(typeProducts);
      }

      renderProducts(similar);

    } catch (error) {
      console.error("Similar products:", error);

      grid.innerHTML =
        '<div class="similar-products-empty">Unable to load similar products.</div>';
    }
  });

  /* Close button */
  if (close) {
    close.addEventListener("click", () => {
      modal.classList.remove("active");
      document.body.style.overflow = "";
    });
  }

  /* Click outside popup content to close */
  if (overlay) {
    overlay.addEventListener("click", event => {
      if (event.target === overlay) {
        modal.classList.remove("active");
        document.body.style.overflow = "";
      }
    });
  }

  /* Escape key closes popup */
  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && modal.classList.contains("active")) {
      modal.classList.remove("active");
      document.body.style.overflow = "";
    }
  });

  function closeModal() {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }

  close?.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") closeModal();
  });

  function escapeHTML(value) {
    const div = document.createElement("div");
    div.textContent = value || "";
    return div.innerHTML;
  }
});
(function () {
  'use strict';

  document.addEventListener('click', function (event) {

    const concierge = event.target.closest('#cc-pdp-zoko-concierge');

    if (!concierge) return;

    event.preventDefault();

    const productUrl =
      window.location.origin + window.location.pathname;

    const message =
      productUrl + '\nHi there! ';

    const zokoWhatsAppUrl =
      'https://api.whatsapp.com/send/?phone=15557243933' +
      '&text=' + encodeURIComponent(message) +
      '&type=phone_number' +
      '&app_absent=0';

    window.open(
      zokoWhatsAppUrl,
      '_blank',
      'noopener'
    );

  });

})();


/* =====================================================
   CONFIDENTIAL COUTURE — INSTANT SEARCH FIX
   Close autocomplete on Enter and after search navigation
   ===================================================== */

(function () {
  'use strict';

  const STORAGE_KEY = 'cc_instant_search_dismissed';
  const POPUP_SELECTOR = '.instant-search-data';

  const SEARCH_INPUT_SELECTOR = [
    'input[type="search"]',
    'input[name="q"]',
    'input[name="query"]',
    'input[id*="Search"]',
    'input[class*="search"]'
  ].join(',');

  let observer = null;
  let scanScheduled = false;
  let localSuppressed = false;

  function isSuppressed() {
    try {
      return localSuppressed ||
        sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return localSuppressed;
    }
  }

  function suppressPopup() {
    localSuppressed = true;

    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      // Continue with page-level suppression if storage is blocked.
    }

    hidePopups();
  }

  function allowPopup() {
    localSuppressed = false;

    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage may be unavailable.
    }

    document.querySelectorAll(
      POPUP_SELECTOR + '.cc-search-dismissed'
    ).forEach(function (popup) {
      popup.classList.remove('cc-search-dismissed');
    });
  }

  function hidePopups() {
    if (!isSuppressed()) return;

    document.querySelectorAll(POPUP_SELECTOR).forEach(function (popup) {
      popup.classList.add('cc-search-dismissed');
    });
  }

  function isSearchInput(element) {
    return element instanceof Element &&
      element.matches(SEARCH_INPUT_SELECTOR);
  }

  /* Close suggestions when the customer presses Enter. */
  document.addEventListener('keydown', function (event) {
    if (!isSearchInput(event.target)) return;

    if (event.key === 'Enter' && !event.isComposing) {
      suppressPopup();

      // Do not prevent the default action:
      // Shopify's normal search submission must continue.
      return;
    }

    /* Allow autocomplete again when the customer edits the query. */
    if (
      event.key.length === 1 ||
      event.key === 'Backspace' ||
      event.key === 'Delete'
    ) {
      allowPopup();
    }
  }, true);

  /* Support pasting or dropping a new search query. */
  document.addEventListener('paste', function (event) {
    if (isSearchInput(event.target)) {
      allowPopup();
    }
  }, true);

  document.addEventListener('drop', function (event) {
    if (isSearchInput(event.target)) {
      allowPopup();
    }
  }, true);

  /* Also close the popup when search is submitted by clicking the icon. */
  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (
      form instanceof HTMLFormElement &&
      form.querySelector(SEARCH_INPUT_SELECTOR)
    ) {
      suppressPopup();
    }
  }, true);

  /* Restore suppression after Shopify navigates to search results. */
  function initialize() {
    hidePopups();

    if (!document.body || observer) return;

    observer = new MutationObserver(function () {
      if (isSuppressed() && !scanScheduled) {
        scanScheduled = true;

        requestAnimationFrame(function () {
          scanScheduled = false;
          hidePopups();
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }
})();


(function () {
  'use strict';

  if (window.__ccINRCurrencyFix) return;

  // Run ONLY for India's Shopify Market and INR currency.
  function isIndiaINR() {
    return (
      document.documentElement.dataset.ccCountry === 'IN' &&
      window.Shopify?.currency?.active === 'INR'
    );
  }

  if (!isIndiaINR()) return;

  window.__ccINRCurrencyFix = true;

  const PRICE_SELECTOR = '.money, .instant-search-data';

  function cleanText(node) {
    if (
      !node ||
      node.nodeType !== Node.TEXT_NODE ||
      !node.nodeValue.includes('$') ||
      !isIndiaINR()
    ) return;

    if (node.parentElement?.closest(PRICE_SELECTOR)) {
      node.nodeValue = node.nodeValue.replace(/\$/g, '');
    }
  }

  function processPriceArea(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    let node;

    while ((node = walker.nextNode())) {
      cleanText(node);
    }
  }

  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      cleanText(node);
      return;
    }

    if (!(node instanceof Element)) return;

    const priceParent = node.matches(PRICE_SELECTOR)
      ? node
      : node.closest(PRICE_SELECTOR);

    if (priceParent) {
      processPriceArea(priceParent);
    }

    node.querySelectorAll(PRICE_SELECTOR).forEach(processPriceArea);
  }

  document.querySelectorAll(PRICE_SELECTOR).forEach(processPriceArea);

  const observer = new MutationObserver(function (records) {
    if (!isIndiaINR()) return;

    records.forEach(function (record) {
      if (record.type === 'characterData') {
        processNode(record.target);
      }

      if (record.type === 'childList') {
        record.addedNodes.forEach(processNode);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true
  });

})();
